import React, { useState } from 'react';


const Label = () => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpansion = () => {
    setExpanded(!expanded);
  };

  const cards = [
    { name: 'NAAC', color: '#660033', link: '/iqac' },
    { name: 'IQAC', color: '#024621', link: '/iqac' },
    { name: 'Library', color: '#FFC543', link: '/library' },
    { name: 'Activities', color: '#660033', link: '/activity' },
    
  ];

  const handleCardClick = (link) => {
    console.log(`Navigating to: ${link}`);
    // You can replace this with actual navigation logic
    window.location.href = link;
    // Or with React Router: navigate(link);
  };

  return (
    <section className="about-us">
      <div className="container">
        <div className="row">
          {/* <div className="col">
            <h1 className="heading-text">ABOUT US</h1>
            <div className={`about-content ${expanded ? 'expanded' : ''}`}>
              <p>
                Calcutta Girls' College has established itself as an institution of higher learning that encourages young women towards academic betterment, self-reliance, and gaining awareness of a meaningful role in society.
                {expanded || window.innerWidth >= 768 ? (
                  <>
                    {' '}The college offers its students modernized academic and infrastructural facilities, individual attention, provisions for various co-curricular activities, programs for career guidance and placements. The college has been recognized by the UGC under 2(b) and 12(f) and offers honors courses in B.A. (Bengali, Education, English, Hindi, History, Political Science, and Urdu) B.Sc. (Economics) and B.com streams along with General courses. The college also functions as the Study Centre for Postgraduate classes under the Directorate of Distance Learning program of Vidyasagar University (Bengali, Commerce, English, History, and Political Science).
                  </>
                ) : (
                  <span className="read-more-text" onClick={toggleExpansion}>
                    .. Read More
                  </span>
                )}
              </p>
            </div>
          </div> */}
        </div>

        <div className="cards-row">
          {cards.map((card, index) => (
            <div key={index} className="card-col">
              <div
                className="info-card"
                style={{ backgroundColor: card.color }}
                onClick={() => handleCardClick(card.link)}
              >
                <h3 className="card-title">{card.name}</h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      <style jsx>{`
        .container {
          width: 100%;
          padding: 0 15px;
          margin: 0 auto;
        }

        .row {
          display: flex;
          flex-wrap: wrap;
          margin: 0 -15px;
        }

        .col {
          flex: 1;
          padding: 0 15px;
        }

        .cards-row {
          display: grid;
          grid-template-columns: repeat(4, 1fr);
          gap: 20px;
          margin-top: 50px;
          margin-bottom: 40px;
        }

        .card-col {
          width: 100%;
        }

        .info-card {
          padding: 40px 20px;
          border-radius: 10px;
          cursor: pointer;
          transition: all 0.3s ease;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
          display: flex;
          align-items: center;
          justify-content: center;
          height: 50px;
        }

        .info-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
        }

        .card-title {
          color: white;
          font-size: 24px;
          font-weight: bold;
          margin: 0;
          text-align: center;
          text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);
        }

        @media (max-width: 992px) {
          .cards-row {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (max-width: 576px) {
          .cards-row {
            grid-template-columns: 1fr;
          }
          
          .info-card {
            min-height: 120px;
          }

          .card-title {
            font-size: 20px;
          }
        }
      `}</style>
    </section>
  );
};

export default Label;